module.exports = __webpack_public_path__ + "img/icontemperatura.ba1f5316.png";